import React from 'react';
import i18next from 'i18next';
import { Link } from 'react-router-dom';
import Tooltip from 'components/tooltip';
import { TableFilter, QuickFilter, FilterButton } from 'containers';
import { roles } from 'shared/constants';
import IconButton from 'components/controls/icon-button';
import DownloadIcon from 'img/download.svg';
import ToolBar from './toolbar';

export default function OrderToolbar({
  filterFields,
  quickFilterFields,
  tableId,
  onExportToFile,
  authDataIm,
  hideAddButton = false,
  productType,
  tableGetSignal,
}) {
  let filterContent;

  if (filterFields) {
    filterContent = (
      <TableFilter
        id={tableId}
        filterFields={filterFields}
        filterSignal={tableGetSignal}
      />
    );
  }

  const currentUserRole = authDataIm.getIn(['data', 'role']);

  // eslint-disable-next-line no-param-reassign
  if (currentUserRole === roles.ACCOUNTANT) hideAddButton = true;

  return (
    <ToolBar className="toolbar_page-tabs">
      <div className="toolbar__item">
        {
          !hideAddButton ? (
            <Link to={`/orders/add/${productType.toLowerCase()}`} className="button button_submit" >
              {i18next.t('add')}
            </Link>
          ) : null
        }
        {
          !hideAddButton && quickFilterFields ? (
            <div className="toolbar__space" />
          ) : null
        }
        {
          quickFilterFields ? (
            <QuickFilter
              id={tableId}
              quickFilterFields={quickFilterFields}
              filterSignal={tableGetSignal}
            />
          ) : null
        }
      </div>

      {
        filterFields ? (
          <div className="toolbar__item">
            <div className="controls-group">
              {
                currentUserRole !== roles.PARTNER ? (
                  <div className="controls-group__control">
                    <IconButton
                      icon={DownloadIcon}
                      onClick={onExportToFile}
                      text={i18next.t('export_to_csv')}
                    />
                  </div>
                ) : null
              }
              <div className="controls-group__control">
                <Tooltip
                  content={filterContent}
                >
                  <FilterButton
                    id={tableId}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        ) : null
      }
    </ToolBar>
  );
}
